<template>
    <aside
        class="main-sidebar elevation-4 sidebar-dark-primary" 
        :class="{'sidebar-collapsed': isCollapsed && !isHovered && !isMobile, 'sidebar-expanded': isHovered || isMobileExpanded}" 
        style="padding-top: 0px; height: 100vh"
        @mouseover="expandMenu"
        @mouseleave="collapseMenu"
    >
        <a class="brand-link" @click="$router.push('/')">
            <img 
                :src="manager?.logo" 
                style="max-height: 200px" class="rounded mx-auto d-block"
            />
        </a>

        <div class="sidebar">
            <nav class="mt-2">
                <b-nav vertical pills>
                    <b-nav-item
                        v-if="teatro?.division_id == 3 && !isTaquilleroVisitante"
                        exact-active-class="active"
                        :to="{ name: 'back.dashboard.club' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-tachometer-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Dashboard</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="!manager?.lfp && (permisos?.['abonos.vender'] || permisos?.['abonos.informe'])"
                        exact-active-class="active"
                        :to="{ name: 'back.abonos.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-id-card-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Venta de abonos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="manager?.tipo == 1 && !manager?.lfp && permisos?.['abonos.vender']" 
                        exact-active-class="active"
                        :to="{ name: 'back.simpatizantes.venta' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-hands-helping"></i> Venta de {{ configuracion?.simpatizantes }}
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['eventos.vender']"
                        exact-active-class="active"
                        :to="{ name: 'back.events.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-calendar-week"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Eventos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['abonos.vender']"
                        exact-active-class="active"
                        :to="{ name: 'back.abonados.index', params: { lista_id: lista_id } }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-address-card"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Abonados</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="teatro?.familia_abonados_activa && pendingFamiliasCount > 0"
                        exact-active-class="active"
                        :to="{ name: 'back.familias.index', params: { lista_id: lista_id }, query: { estado: 'pendiente' } }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-users"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Familias</span>
                        <Badge
                            v-if="pendingFamiliasCount"
                            variant="danger"
                            custom-class="tw:ml-2 tw:bg-red-500 tw:text-white tw:inline-flex tw:items-center tw:justify-center tw:min-w-[1.25rem] tw:h-5 tw:px-1.5 tw:rounded-full tw:text-xs tw:font-bold tw:normal-case"
                        >{{ pendingFamiliasCount }}</Badge>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['abonos.vender']"
                        exact-active-class="active"
                        :to="{ name: 'back.envios.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-shipping-fast"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Envíos</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="manager?.tipo == 1 && permisos?.['abonos.vender']" id="navbar-simpatizantes"
                        exact-active-class="active"
                        :to="{ name: 'back.simpatizantes.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon far fa-handshake"></i> <span style="text-transform: capitalize;"> {{ configuracion?.simpatizantes }}</span>
                    </b-nav-item>
                    <b-nav-item
                        v-if="permisos?.['taquilleros.gestion']"
                        exact-active-class="active"
                        :to="{ name: 'back.taquilleros.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-users-cog"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Usuarios</span>
                    </b-nav-item>
                    <b-nav-item
                        v-b-toggle.marketing-collapse
                        v-if="permisos?.['comunicaciones']"
                        @click="toggleCollapseMarketing"
                    >
                        <i class="nav-icon fas fa-bullhorn"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Marketing</span>
                        <i :class="isCollapsedMarketing ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>

                    <b-collapse id="marketing-collapse" class="pl-2 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.comunicados.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-rss"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Comunicados</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.plantillas-whatsapp.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fab fa-whatsapp"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Plantillas WhatsApp</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.upselling.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-chart-line"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Upselling</span>
                        </b-nav-item>  
                    </b-collapse>
                    <div v-if="listaAbonados.activar_parcelas">
                        <b-nav-item
                            v-b-toggle.parcelas-collapse
                            v-if="true"
                            @click="toggleCollapseParcelas"
                        >
                            <i class="nav-icon fas fa-th"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">{{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }}</span>
                            <i :class="isCollapsedParcelas ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                        </b-nav-item>
    
                        <b-collapse id="parcelas-collapse" class="pl-2 ml-3">
                            <b-nav-item
                                exact-active-class="active"
                                :to="{ name: 'back.precios.parcelas.index' }"
                                @click="closeMenuOnMobile"
                            >
                                <i class="nav-icon fas fa-layer-group"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Gestión de {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }}</span>
                            </b-nav-item>
                            <b-nav-item
                                exact-active-class="active"
                                :to="{ name: 'back.venta.parcelas' }"
                                @click="closeMenuOnMobile"
                            >
                                <i class="nav-icon fas fa-shopping-cart"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Venta</span>
                            </b-nav-item>
                            <b-nav-item
                                exact-active-class="active"
                                :to="{ name: 'back.listado.parcelas.vendidas' }"
                                @click="closeMenuOnMobile"
                            >
                                <i class="nav-icon fas fa-file-contract"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">{{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }} vendidas</span>
                            </b-nav-item>
                            <b-nav-item
                                exact-active-class="active"
                                :to="{ name: 'back.listado.parcelas.informe' }"
                                @click="closeMenuOnMobile"
                            >
                                <i class="fas fa-chart-bar"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Informe</span>
                            </b-nav-item>
                        </b-collapse>
                    </div>
                    
                    <b-nav-item v-b-toggle.emails-collapse @click="toggleCollapseCampanaEmails" v-if="teatro.marketing_api_token">
                        <i class="nav-icon fas fa-envelope"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Campaña Emails</span>
                        <i :class="isCollapsedCampanaEmails ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>

                    <b-collapse id="emails-collapse" class="pl-2 ml-3">
                        <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.dashboard' }" @click="closeMenuOnMobile">
                            <i class="fas fa-tachometer-alt"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Dashboard</span>
                        </b-nav-item>

                        <b-nav-item
                            v-b-toggle.subscriptores-collapse
                            @click="toggleCollapseSubscriptores"
                        >
                            <i class="fas fa-users"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Subscriptores</span>
                            <i :class="isCollapsedSubscriptores ? 'fa fa-arrow-down pl-2' : 'fa fa-arrow-up pl-2'"></i>
                        </b-nav-item>

                        <b-collapse id="subscriptores-collapse" class="pl-2 ml-3">
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.subscriptores.index' }" @click="closeMenuOnMobile">
                                <i class="fas fa-users"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Subscriptores</span>
                            </b-nav-item>
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.grupos.index' }" @click="closeMenuOnMobile">
                                <i class="fas fa-users-cog"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Grupos</span>
                            </b-nav-item>
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.importaciones' }" @click="closeMenuOnMobile">
                                <i class="fas fa-file-import"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Importaciones</span>
                            </b-nav-item>
                        </b-collapse>

                        <b-nav-item
                            v-b-toggle.boletines-collapse
                            @click="toggleCollapseBoletines"
                        >
                            <i class="fas fa-newspaper"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Boletines</span>
                            <i :class="isCollapsedBoletines ? 'fa fa-arrow-down pl-2' : 'fa fa-arrow-up pl-2'"></i>
                        </b-nav-item>

                        <b-collapse id="boletines-collapse" class="pl-2 ml-3">
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.boletines.index' }" @click="closeMenuOnMobile">
                                <i class="fas fa-newspaper"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Boletines</span>
                            </b-nav-item>
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.remitentes.index' }" @click="closeMenuOnMobile">
                                <i class="fas fa-envelope"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Remitentes</span>
                            </b-nav-item>
                            <b-nav-item exact-active-class="active"  @click="closeMenuOnMobile" :to="{ name: 'back.emails.plantilla.index' }">
                                <i class="fas fa-shapes"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Plantillas</span>
                            </b-nav-item>
                        </b-collapse>
                        <b-nav-item
                            v-b-toggle.informes-collapse
                            @click="toggleCollapseInformes"
                        >
                            <i class="fas fa-chart-bar"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Informes</span>
                            <i :class="isCollapsedInformes ? 'fa fa-arrow-down pl-2' : 'fa fa-arrow-up pl-2'"></i>
                        </b-nav-item>
                        <b-collapse id="informes-collapse" class="pl-2 ml-3">
                            <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.informes.boletines-enviados' }" @click="closeMenuOnMobile">
                                <i class="fas fa-paper-plane"></i>
                                <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Boletines enviados</span>
                            </b-nav-item>
                        </b-collapse>
                        <b-nav-item exact-active-class="active" :to="{ name: 'back.emails.gestor-de-medios' }" @click="closeMenuOnMobile">
                            <i class="fas fa-photo-video"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Gestor de medios</span>
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                        v-b-toggle.deportistas-collapse
                        v-if="permisos?.['bases.informe']"
                        @click="toggleCollapseDeportistas"
                    >
                        <i class="nav-icon fas fa-child"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Deportistas</span>
                        <i :class="isCollapsedDeportistas ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>

                    <b-collapse id="deportistas-collapse" class="pl-2 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.bases.index', params: { lista_id: lista_id } }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-list"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Listado</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.bases.recogida-indumentarias', params: { lista_id: lista_id } }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-tshirt"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Recogida indumentarias</span>
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                        v-if="permisos?.['taquilleros.gestion']"
                        exact-active-class="active"
                        :to="{ name: 'back.acreditaciones.index', params: { lista_id: lista_id } }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fas fa-ticket-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Acreditaciones</span>
                    </b-nav-item>
                    <b-nav-item
                        v-b-toggle.collapse-2
                        v-if="permisos?.['taquilleros.gestion']"
                        @click="toggleCollapseConfiguracion"
                    >
                        <i class="nav-icon fas fa-cogs"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Configuración</span>
                        <i :class="isCollapsedConfiguracion ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>
                    <b-collapse id="collapse-2" class="pl-2 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.configuracion.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-sliders-h mr-1"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">General</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.formularios.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-clipboard mr-1"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Formularios</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.campana-abonos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fa fa-newspaper mr-1"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Campaña de abonados</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.compania-eventos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-calendar-week"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Compañia eventos</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.deportistas.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-child"></i>
                            <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Deportistas</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.productos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-box mr-1"></i>
                            <span class="pl-1" v-if="!isCollapsed || isHovered || isMobileExpanded">Productos</span>
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.etiquetas-bloqueos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-tag mr-1"></i>
                            <span class="pl-1" v-if="!isCollapsed || isHovered || isMobileExpanded">Etiquetas de bloqueos</span>
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                        v-if="permisos?.['taquilleros.gestion']"
                        :to="{name: 'back.mensajes.index'}"
                        exact-active-class="active"
                    >
                        <i class="far fa-comment-dots"></i>
                        <span v-if="!isCollapsed || isHovered || isMobileExpanded" class="pl-2">Mensajes</span>
                        <b-badge v-if="numMensaje" class="ml-2" variant="danger">{{numMensaje}}</b-badge>
                    </b-nav-item>

                    <b-nav-item
                        v-b-toggle.collapse-1
                        v-if="permisos?.['liquidaciones']"
                        @click="toggleCollapseLiquidaciones"
                    >
                        <i class="nav-icon fas fa-calculator"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Liquidaciones</span>
                        <i :class="isCollapsedLiquidaciones ? 'nav-icon fa fa-arrow-down pl-2' : 'nav-icon fa fa-arrow-up pl-2'"></i>
                    </b-nav-item>
                    <b-collapse id="collapse-1" class="mt-2 pl-3 ml-3">
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.abonos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-ticket-alt"></i>
                            Abonos
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.eventos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-calendar-check"></i>
                            Eventos
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.productos.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-box"></i>
                            Productos
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.bases.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-futbol"></i>
                            Cantera
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.liquidaciones.parcelas.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="fas fa-th"></i>
                            {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }}
                        </b-nav-item>
                        <b-nav-item
                            exact-active-class="active"
                            :to="{ name: 'back.facturas.index' }"
                            @click="closeMenuOnMobile"
                        >
                            <i class="nav-icon fas fa-file-invoice"></i>
                            <span class="pl-1">Facturas comisiones bancarias</span>
                        </b-nav-item>
                    </b-collapse>
                    <b-nav-item
                        exact-active-class="active"
                        :to="{ name: 'back.faqs.index' }"
                        @click="closeMenuOnMobile"
                    >
                        <i class="nav-icon fa fa-question"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Preguntas frecuentes</span>
                    </b-nav-item>
                    <b-nav-item
                        @click.prevent="logout"
                    >
                        <i class="nav-icon fas fa-sign-out-alt"></i>
                        <span class="pl-2" v-if="!isCollapsed || isHovered || isMobileExpanded">Salir</span>
                    </b-nav-item>
                </b-nav>
            </nav>
        </div>
    </aside>
</template>

<script>
    import { fetchPendingCountFamilias, getPendingCountFamilias } from '@/composables/admin/abonados/useFamilias';
    import { esTeatroConVentaExenta } from '@/composables/admin/abonos/teatrosConVentaExenta';

    export default {
        props: ['sidebar'],
        created() {
            this.getNotificationMensajes();
            this.fetchPendingFamiliasCount();
            this.visibilityHandlerFamilias = () => {
                if (!document.hidden) this.fetchPendingFamiliasCount();
            };
            document.addEventListener('visibilitychange', this.visibilityHandlerFamilias);
            this.checkMobile();
            window.addEventListener('resize', this.checkMobile);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile);
            document.removeEventListener('visibilitychange', this.visibilityHandlerFamilias);
        },
        data() {
            return {
                intervalo: null,
                visibilityHandlerFamilias: null,
                numMensaje: 0,
                pendingFamiliasCount: 0,
                isCollapsedConfiguracion: true,
                isCollapsedLiquidaciones: true,
                isCollapsedMarketing: true,
                isCollapsedCampanaEmails: true,
                isCollapsedSubscriptores: true,
                isCollapsedBoletines: true,
                isCollapsedInformes: true,
                isCollapsedParcelas: true,
                isCollapsedDeportistas: true,
                isHovered: false,
                isMobile: false,
                isMobileExpanded: false,
                collapsed: false
            }
        },
        mounted() {
            if (this.user && this.user.id) {
                this.$echo.channel('manager.incidencia.' + this.user.id).on('sum.incidencia', e => {
                    this.numMensaje = this.numMensaje + 1;
                });
            }
            // TODO(websockets): backend does not yet dispatch sum.familia.pendiente on manager.incidencia.{userId}.
            // When backend ships it, mirror the Mensajes pattern:
            //   this.$echo.channel('manager.incidencia.' + this.user.id).on('sum.familia.pendiente', e => {
            //       this.fetchPendingFamiliasCount();
            //   });
            // Subscribe to the shared ref so manual approve/reject/delete in the
            // familias view (which call fetchPendingCountFamilias) update the badge
            // without prop-drilling.
            this.$watch(
                () => getPendingCountFamilias().value,
                newCount => {
                    this.pendingFamiliasCount = newCount;
                },
                { immediate: true }
            );
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            user() {
                return this.$store.getters.getUser;
            },
            isCollapsed() {
                return this.collapsed || this.sidebar.includes('sidebar-collapse');
            },
            lista_id() {
                return this.$store.getters.getListaId;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            // El taquillero del club visitante (rol 11) no ve la dashboard del equipo local
            isTaquilleroVisitante() {
                return this.user && this.user.role === 11;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            // Algunos teatros necesitan ver el backoffice de "Venta de abonos"
            // aunque tengan `ocultar_abonos` activo (su venta al público está
            // oculta pero siguen necesitando informes, configuración, etc.).
            // La lista de hashes exentos vive en un módulo aparte y es la
            // única fuente de verdad — también la consulta el guard del router.
            esTeatroExento() {
                return esTeatroConVentaExenta(this.configuracion?.hash_teatro);
            }
        },
        components: {
            Badge: () => import('@/modules/admin/ui/Badge.vue'),
        },
        methods: {
            logout() {
                this.$store.dispatch('logout', { router : this.$router });
            },
            getNotificationMensajes() {
                const params = {
                    filters: {},
                }
                this.$store.dispatch(this.config.getVuexAlias('back.mensajeria.notifications'), params).then(res => {
                    this.numMensaje = this.numMensaje + res.data.numMensaje;
                })
            },
            fetchPendingFamiliasCount() {
                // El watcher en mounted() ya refleja el ref compartido en este estado local.
                fetchPendingCountFamilias().catch(() => {
                    // Silent fail — el item no se muestra si el count queda en 0.
                });
            },
            toggleCollapseConfiguracion() {
                this.isCollapsedConfiguracion = !this.isCollapsedConfiguracion;
            },
            toggleCollapseLiquidaciones() {
                this.isCollapsedLiquidaciones = !this.isCollapsedLiquidaciones;
            },
            toggleCollapseMarketing() {
                this.isCollapsedMarketing = !this.isCollapsedMarketing;
            },
            toggleCollapseCampanaEmails() {
                this.isCollapsedCampanaEmails = !this.isCollapsedCampanaEmails;
            },
            toggleCollapseSubscriptores() {
                this.isCollapsedSubscriptores = !this.isCollapsedSubscriptores;
            },
            toggleCollapseBoletines() {
                this.isCollapsedBoletines = !this.isCollapsedBoletines;
            },        toggleCollapseInformes() {
                this.isCollapsedInformes = !this.isCollapsedInformes;
            },
            toggleCollapseParcelas() {
                this.isCollapsedParcelas = !this.isCollapsedParcelas;
            },
            toggleCollapseDeportistas() {
                this.isCollapsedDeportistas = !this.isCollapsedDeportistas;
            },
            expandMenu() {
                if (this.isCollapsed && !this.isMobile) {
                    this.isHovered = true;
                }
            },
            collapseMenu() {
                if (!this.isMobile) {
                    this.isHovered = false;
                }
            },
            checkMobile() {
                this.isMobile = window.innerWidth <= 1000;
                if (this.isMobile) {
                    this.collapsed = false; // Now using the 'collapsed' data property
                }
            },
            closeMenuOnMobile() {
                if (this.isMobile) {
                    this.$emit('collapse');
                }
            }
        },
        watch: {
            isMobile(newVal) {
                if (newVal) {
                    this.isMobileExpanded = true;
                } else {
                    this.isMobileExpanded = false;
                }
            }
        }
    }
</script>

<style scoped>
    .sidebar-collapsed .b-nav-item span,
    .sidebar-expanded .b-nav-item span {
        display: none;
    }
    @media (max-width: 995px) {
        .b-nav-item span {
            display: inline !important;
        }
    }
    @media (max-width: 995px) {
        .main-sidebar, .main-sidebar::before {
            box-shadow: none !important;
            margin-left: -250px;
        }
        .sidebar-open .main-sidebar, .sidebar-open .main-sidebar::before {
            margin-left: 0;
        }
    }
    .sidebar::-webkit-scrollbar {
        width: 6px;
    }

    .sidebar::-webkit-scrollbar-track {
        background: transparent;
    }

    .sidebar::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 10px;
    }

    .sidebar::-webkit-scrollbar-thumb:hover {
        background-color: #555;
    }
</style>
